/* eslint-disable eslint-comments/disable-enable-pair */
/* eslint-disable react/no-unknown-property */
/* eslint-disable import/exports-last */
/** @jsx jsx */
// eslint-disable-next-line no-unused-vars
import React from 'react'
import { jsx } from 'theme-ui'

export const Family = ({ ...props }) => (
  <svg
    x="0px"
    y="0px"
    width="80.5px"
    height="81.5px"
    viewBox="0 0 80.5 81.5"
    sx={{
      '.st0': {
        fill: 'none',
        stroke: props.color || 'primary',
        strokeWidth: '2',
        strokeLinecap: 'round',
        strokeLinejoin: 'round',
        strokeMiterlimit: '10',
      },
    }}
    {...props}
  >
    <path
      className="st0"
      d="M37.5 32.5c0-4.5.13-9-.03-13.5C37.12 9.04 30.76 2.29 21 2.15 12.32 2.02 4.64 8.73 5 19c.32 9.16-.63 18.35.5 27.5M46.5 67.5c3.19-3.1 4.23-7.79 7.97-10.53 2.82-2.06-.73-3.88-.54-5.97.33-3.75-.53-7.17-3.39-10.03-3.5-3.5-7.22-4.61-12.06-3.04-5.08 1.65-7.03 5.4-7.95 10.08-.4 2.03.81 4.44-1.49 6.05-.12.09.15 1.11.49 1.42 3.49 3.27 4.35 8.43 8.03 11.46 2.47 2.03 5.57 1.1 8.45.56M47 21c-3.37 2-1.19 4.94.13 5.81 2.83 1.86 4.14 4.63 5.25 7.25 3.09 7.27 13.28 8.23 17.17.97 1.68-3.14 3.17-6.53 6.44-8.54.67-.41 1.33-1.06 1-1.98-2.24-6.09-.27-13.49-5.96-18.53C66.75 2.19 60.3 1.02 55.5 3.5c-5.95 3.07-8.73 8.08-7.99 14.5.16 1.37-.91 3.06 1.31 4.16 2.84-2.95 3.77-6.69 3.89-11.57 5.82 1.96 11.32 1.91 16.93.05 1.4 3.16.88 6.5 2.28 9.4.86 1.79 1.67 1.85 3.08.96"
    />
    <path
      className="st0"
      d="M17.5 14.5c.01 3.91 1.68 5.74 5.5 6 3.33.22 6.71-.46 10.07.44-.51 5.47-1.54 10.59-5.01 15.11-4.41 5.73-9.8 6.13-14.02.43-3.15-4.25-4.87-9.12-4.73-14.85 1.7-1.9 5.63-.56 7.2-3.62M49.5 50.5c.59-1.67.84-3.33.03-5.25H35.37c-.32 1.9-.6 3.57-.87 5.25M33 73c2.94 6.06 10.62 8.08 15.47 3.97 1.34-1.13 2.36-2.64 3.53-3.97M10 47c1.67 7.22 6.39 12.57 10.48 18.14 2.87-.8 3.09-3.58 5.02-4.64M38 68.5c-2.71 4.19-7.58 3.83-11.47 5.56-3.17 1.41-7.39 1.77-8.03 6.44M47 68c.39 1.94 1.4 2.83 3.44 3.64 5.65 2.23 12.55 2.35 16.05 8.61.04.06 0 .16 0 .25M73 43.5c-2.64 4.12-4.29 9.33-10.5 9.5M26 39.5c1.06 2.61.22 5.34.5 8M67 39.5c2.01 2.21 4.89 2.61 7.51 3.46 1.82.59 3.73.88 4.99 2.54M16 39.5c-.33 1.5-.67 3-.95 4.29-3.81 2.96-9.37 1.64-12.55 5.71"
    />
  </svg>
)

export const Communication = ({ ...props }) => (
  <svg
    x="0px"
    y="0px"
    width="78.49px"
    height="79.75px"
    viewBox="0 0 78.49 79.75"
    sx={{
      '.st0': {
        fill: 'none',
        stroke: props.color || 'primary',
        strokeWidth: '2',
        strokeLinecap: 'round',
        strokeLinejoin: 'round',
        strokeMiterlimit: '10',
      },
    }}
    {...props}
  >
    <style>
      {`.st0{fill:none;stroke:${
        props.color || '#000'
      };stroke-width:2;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10}`}
    </style>
    <path
      className="st0"
      d="M34.5 40c1.72-2.4-1.42-6.46 2.07-7.83 2.31-.9 5.26-.17 7.93-.17 4 0 8 .03 12-.01 3.26-.03 4.97-1.74 4.99-4.99.04-6.67-.02-13.33.02-20 .02-3.09-1.41-4.52-4.51-4.51-11.33.03-22.67.05-34-.02-2.86-.02-4.06 1.17-4.03 4.03.08 7 .12 14-.04 21-.04 1.91.84 3.83 2.07 3.85 6.33.1 8.58 5.95 13 8.65M28 67.5c.28-7.33-4.72-12.76-11.5-12.51-1.5.06-3 .01-5.41.01-3.47 2.88-8.72 5.65-8.57 13.25h27.04c.61 1.08.43 1.26-.03 1.78-1.74 1.97-3.14 4.7-2.33 6.9 1.08 2.94 4.44 1.41 6.81 1.51 4.66.2 9.33.07 14 .05 5.33-.02 6.04-1.02 3.94-5.97-.36-.84-.25-2.11-1.44-2.48.9-6.79 3.93-12.15 10.67-15.42 1.82.43 4.32.83 6.82-.12 4.82 3.08 9.63 6.15 9.49 13.5H52M20 53.5c5.3-5.75 4.7-11.84-1.51-14.48-3.06-1.3-6-.77-8.48 1.49C7.28 43 6.84 46.09 7.99 49.5c.56 1.68 1.79 2.83 3.01 4M69 53.5c3.4-2.61 4.49-5.99 2.97-9.99-1.27-3.33-3.73-5.05-7.47-5.05-3.73 0-6.2 1.72-7.47 5.05-1.53 3.99-.44 7.38 2.97 9.99M51.5 10h-23M51.5 17h-23M51.5 23.5c-7.67-.82-15.33-.82-23 0M35.5 65L30 69M44.5 65l5.5 4"
    />
    <path
      className="st0"
      d="M37.5 48.5c-1.17 1-2.35 1.98-3.5 3-2.55 2.27-2.86 5.35-1.37 7.92 1.55 2.66 2.96 6.1 7.37 5.65 3.43-.35 8.49-5.1 8.49-8.57 0-3.41-4.4-7.82-8-7.99-.83-.04-1.67-.01-2.5-.01"
    />
  </svg>
)

export const Ribbon = ({ ...props }) => (
  <svg
    x="0px"
    y="0px"
    width="81px"
    height="87px"
    viewBox="0 0 81 87"
    sx={{
      '.st0': {
        fill: 'props.stroke',
        stroke: props.color || 'primary',
        strokeWidth: '2',
        strokeLinecap: 'round',
        strokeLinejoin: 'round',
        strokeMiterlimit: '10',
      },
    }}
    {...props}
  >
    <path
      className="st0"
      d="M70.5 33.5c.85-2.33 1.69-4.66 2.95-8.12-.53-.3-1.43-1.13-2.46-1.33-4.26-.82-5.49-3.61-5.55-7.55-.03-1.68-.23-3.99-2.93-3.47-4.72.92-6.85-1.85-8.52-5.53-.34-.75-.91-1.39-1.52-2.31-5.22 2.75-10.05 2.81-14-2.93-3.65 5.85-8.23 7.38-13.78 4.07-1.54 1.38-2.08 3.03-2.72 4.66-1.04 2.64-2.83 4.32-5.97 4.03-2.14-.2-4.42.2-3.92 2.97 1.03 5.75-2.05 8.74-6.88 10.9 1.34 2.68 2.57 5.14 3.85 7.72-1.45 2.29-2.94 4.63-4.44 7.01.72.72 1.46 1.69 2.41 2.36 2.86 2.02 5.06 3.81 3.14 8.1-1.42 3.19 1.52 5 4.35 5.32 2.52.29 3.63 1.87 4.43 3.63 2.57 5.6 3.09 5.94 7.45 4.37l6.96 6.96c4.84-3.82 8.46-6.13 13.23-2.45 1.53 1.18 3.63.48 4.44-1.89 1.23-3.63 3.96-4.49 7.49-4.03 2.88.37 4.68-.7 4.51-3.97-.15-2.8 1.35-4.17 3.96-5.07 3.46-1.19 5.23-3.64 3.5-7.42-.92-2.01-.71-3.56 1-5.03 1.43-1.22 2.69-2.64 3.87-3.83-.46-2.95-3.78-3.86-4.35-6.67"
    />
    <path
      className="st0"
      d="M65 59c3.4 4.28 6.8 8.56 10.62 13.36-4.3 1.28-8.34.2-12.03.77-1.39 3.62-.78 7.43-3.12 11.22-3.42-4.28-6.45-8.06-9.48-11.85M13.5 60c-1.85 4.7-6.33 7.53-8.65 12.22 3.79 1.79 7.91.09 11.59 1 1.36 3.53.74 7.35 3.13 11.2C23.32 79.59 26.66 75.3 30 71M40 24.5c.18 4.65 4.39 9.4 8.5 9.48 1.56.03 3.08-.07 4 1.52M39 27.5c-3.43 6.12-3.43 6.12-12.4 8.21 4.98 3.57 8.88 7.43 5.74 14.37 5.49-3.67 10.32-3.22 15.15-.58M54.5 34.5c-2.22.65-3.37 2.61-5 3.99-2.5 2.12-3.59 4.41-1.54 7.54.73 1.11-1.24 2.84.55 3.97"
    />
    <path
      className="st0"
      d="M35.5 14c-7.25 2.26-13.36 5.94-17.02 12.99-8.61 16.58 4.33 34.83 20.51 35.28 11.53.32 22.23-8.37 24.47-17.78 3.59-15.09-6.09-29.26-21.96-30.47-1.82-.14-3.67-.02-5.5-.02"
    />
  </svg>
)

export const Tools = ({ ...props }) => (
  <svg
    x="0px"
    y="0px"
    width="73px"
    height="73px"
    viewBox="0 0 73 73"
    sx={{
      '.st0': {
        fill: 'none',
        stroke: props.color || 'primary',
        strokeWidth: '2',
        strokeLinecap: 'round',
        strokeLinejoin: 'round',
        strokeMiterlimit: '10',
      },
    }}
    {...props}
  >
    <path
      className="st0"
      d="M45.87 38.47c8.06 7.89 16.08 15.82 24.19 23.66 2.51 2.43 2.55 4.55.01 6.95-1.61 1.52-2.98 3.28-4.8 5.32-10.17-8.95-19.11-18.11-27.78-27.54M34.53 33.54c3.78-3.78 7.42-7.72 11.4-11.29 2.49-2.23 3.34-4.61 3.54-7.94.34-5.53 2.63-9.98 10.98-10.89 1.07 3.81-2.87 4.32-3.81 5.82.03 5.81 2.83 8.77 8.07 9.52 2.31-.92 3.09-3.99 5.89-4.6 1.35.99 1.74 1.91.97 3.62-2.33 5.17-6.15 7.88-11.89 7.84-2.12-.02-3.89.1-5.49 1.95-2.57 2.99-5.89 5.38-8.21 8.52-1.83 2.47-3.76 3.26-6.53 2.88M37.98 40.94c.13 2.24-.19 4.03-2.4 5.52-2.27 1.53-3.91 3.96-6.01 5.79-3.34 2.91-5.07 6.09-5.12 10.88-.06 5.71-5.02 8.2-9.56 10.53-1.71-3-1.71-3 2.85-7.56-1.52-2.97-1-6.8-5.84-8.15-4.66-1.3-5.27 4.38-8.95 3.69C1.82 54.37 9 48.78 16.64 51.41L32.55 35.5M9.86 10.85l22.69 22.69M44.39 45.38L65.11 66.1"
    />
    <path
      className="st0"
      d="M52.28 22.69c-3.29 3.29-6.3 6.94-9.95 9.75-2.86 2.19-1.75 6.89-4.44 7.71-2.72.83-4.9 1.75-6.83 3.74-3.24 3.34-6.56 6.59-9.85 9.88"
    />
  </svg>
)

export const Shield = ({ ...props }) => (
  <svg
    x="0px"
    y="0px"
    width="72px"
    height="77px"
    viewBox="0 0 72 77"
    sx={{
      '.st0': {
        fill: 'none',
        stroke: props.color || 'primary',
        strokeWidth: '2',
        strokeLinecap: 'round',
        strokeLinejoin: 'round',
        strokeMiterlimit: '10',
      },
    }}
    {...props}
  >
    <path
      className="st0"
      d="M67.5 29.5c-1.53-3.91.49-7.66.57-11.95-11.9-2.94-23.94-5.91-32.85-15.41-6.72 4.77-12.65 10.02-20.65 12.11-2.12.55-4.47.82-6.64 1.51-6.2 1.97-6.64 1.57-5.85 8.23.97 8.16 2.38 16.24 5.36 24.03 4.82 12.6 12.31 22.58 25.06 28 .57.24.97.85 1.42 1.25 5.89-1.83 10.41-5.88 15.59-8.78"
    />
    <path
      className="st0"
      d="M29.5 16.5c-5.84 3.09-11.66 6.25-18.59 6.18C10.92 35.54 13.21 47.32 22 57M54 29c10.46.39 16.5 6.98 16.5 18 0 13.1-12.63 21.54-23.99 15.99-9.11-4.45-11.35-9.54-10.33-19.97.68-6.94 5.64-11.31 12.31-13.55 1.74-.58 3.34-.76 5.01.03"
    />
    <path
      className="st0"
      d="M65 35.5c-3.63 3.38-7.26 6.75-10.85 10.09C51.42 44.78 50.3 42.1 48 41M53.5 59.5V64"
    />
  </svg>
)

export const Roof = ({ _styled = true, ...props }) => (
  <svg
    x="0px"
    y="0px"
    width="78px"
    height="32px"
    viewBox="0 0 78 32"
    sx={{
      '.filled': _styled && {
        fill: props.color || 'primary',
        stroke: 'none',
      },
      '.st1': { fill: 'none' },
      '.st2': { fill: 'none' },
    }}
    {...props}
  >
    <path
      className="filled"
      d="M35.02.07h18.96c2.38 3.16 4.66 6.4 7.16 9.46 5.7 6.97 10.22 14.86 16.79 21.15-1.45 2.38-3.69.78-5.49.9-4.47.28-8.98.09-13.47.09C53 21.32 44.78 12.61 37.93 2.74c-5.26 5.96-5.25 5.95-1 11.57 4.37 5.78 8.71 11.58 13.06 17.37H34.02c-3.31-7.14-8.98-12.66-13.54-18.93-1.65-2.27-2.46.42-3.12 1.28-4.5 5.83-8.86 11.75-13.27 17.65H1.1c3.52-6.9 9.14-12.33 13.31-18.77 2-3.09 4.35-4.3 8.15-4.14 7.56.31 9.26-1.11 12.46-8.7z"
    />
    <path
      className="st1"
      d="M35.02.07c-3.2 7.59-4.9 9.01-12.47 8.69-3.8-.16-6.15 1.05-8.15 4.14-4.16 6.44-9.79 11.87-13.31 18.77-1.59.34-.97-.88-.98-1.48C.08 20.97.18 11.75.03 2.54-.01.41.44-.02 2.59 0 13.4.14 24.21.07 35.02.07zM77.93 30.68C71.37 24.39 66.84 16.5 61.15 9.53c-2.5-3.06-4.78-6.3-7.16-9.46C61.14.07 68.3.18 75.44 0c2.15-.05 2.6.41 2.56 2.54-.15 9.38-.07 18.76-.07 28.14z"
    />
    <path
      className="st2"
      d="M4.09 31.67c4.41-5.89 8.77-11.82 13.27-17.65.67-.86 1.47-3.55 3.12-1.28 4.56 6.27 10.23 11.78 13.54 18.93h-9.98c-.11-1.32.98-3.22-1.2-3.63-3.07-.59-1.6 2.59-2.79 3.63h-2c-.09-1.33.98-3.21-1.21-3.63-3.07-.59-1.74 2.49-2.78 3.63H4.09zm12.28-9.74c-1.22-.05-1.73.62-1.76 1.76-.05 1.45.71 2 2.12 1.92 1.39-.07 1.43-1.03 1.44-2.02.02-1.18-.54-1.79-1.8-1.66zM49.99 31.67c-4.35-5.79-8.69-11.59-13.06-17.37-4.25-5.61-4.26-5.6 1-11.57C44.78 12.61 53 21.32 58.97 31.67h-8.98z"
    />
    <path
      className="filled"
      d="M14.07 31.67c1.04-1.14-.29-4.22 2.78-3.63 2.19.42 1.12 2.3 1.21 3.63h-3.99zM20.05 31.67c1.18-1.04-.28-4.22 2.79-3.63 2.18.42 1.09 2.32 1.2 3.63h-3.99zM16.37 21.93c1.26-.13 1.82.48 1.8 1.66-.01.99-.05 1.95-1.44 2.02-1.41.08-2.17-.47-2.12-1.92.04-1.13.55-1.8 1.76-1.76z"
    />
  </svg>
)

export const Siding = ({ _styled = true, ...props }) => (
  <svg
    x="0px"
    y="0px"
    width="40.2px"
    height="44.21px"
    viewBox="0 0 40.2 44.21"
    sx={
      _styled
        ? {
            path: {
              fill: props.color || 'primary',
              stroke: 'none !important',
              strokeWidth: '2',
              strokeLinecap: 'round',
              strokeLinejoin: 'round',
              strokeMiterlimit: '10',
            },
          }
        : {
            path: {
              stroke: 'none !important',
            },
          }
    }
    {...props}
  >
    <path
      className="filled"
      d="M35.1 43.98c-9.33-2.11-18.93-1.97-28.32-3.5-1.63-.27-4.61 1.19-4.28-2.78.28-3.3 1.17-4.89 4.96-4.58 10.82.89 21.67 1.4 32.51 2.06 0 1.3-.2 2.64.04 3.9.78 4.16-.79 5.77-4.91 4.9zM39.97 11.73c-11.04-.13-21.95 1.78-32.95 2.11-1.45.04-4.33 2.14-4.41-1.51-.06-2.69.06-5.29 4.18-5.7 9.67-.96 19.29-2.49 28.92-3.82 1.43-.2 2.84-.57 4.26-.86v9.78zM39.97 22.48c-11.02.09-22.05.26-33.07.2-1.46-.01-4.37 1.63-4.3-1.92.05-2.77.21-5.24 4.41-5.31 11-.18 21.91-2.23 32.96-1.76v8.79zM39.97 33.23c-11.35-.54-22.7-1.04-34.05-1.65-1.46-.08-4.09.83-3.33-2.44.46-1.99-.42-4.79 3.31-4.75 11.36.11 22.71.04 34.07.05v8.79z"
    />
  </svg>
)

export const Windows = ({ _styled = true, ...props }) => (
  <svg
    x="0px"
    y="0px"
    width="40px"
    height="44px"
    viewBox="0 0 40 44"
    sx={
      _styled && {
        '.filled': {
          fill: props.color || 'primary',
          stroke: props.color || 'primary',
          strokeWidth: '2',
          strokeLinecap: 'round',
          strokeLinejoin: 'round',
          strokeMiterlimit: '10',
        },
      }
    }
    {...props}
  >
    <path
      d="M40 20v4H22v20h-4V24H0v-4h12.79c-3.14-3.75-6.1-7.29-9.43-11.27C2.04 11.58 1.02 13.79 0 16V0h16c-3.11 1.59-6.23 3.19-8.69 4.45 3.55 3.99 6.67 7.49 10.69 12.01V0h4v15.2c4.09-3.63 7.6-6.75 11.75-10.43C30.13 2.99 27.06 1.5 24 0h16v15c-1.09-1.91-2.19-3.83-2.56-4.48-3.23 3.25-6.47 6.51-9.43 9.48H40z"
      fill="transparent"
    />
    <path
      className="filled"
      d="M0 24h18v20H0V24zM22 44V24h18v20H22zM24 0c3.06 1.5 6.13 2.99 9.75 4.76C29.6 8.44 26.09 11.57 22 15.2V0h2zM18 0v16.46c-4.02-4.52-7.14-8.02-10.69-12.01C9.77 3.19 12.89 1.59 16 0h2zM40 20H28.01c2.96-2.97 6.2-6.23 9.43-9.48.37.65 1.47 2.57 2.56 4.48v5zM0 16c1.02-2.21 2.04-4.42 3.36-7.27 3.33 3.98 6.29 7.52 9.43 11.27H0v-4z"
    />
  </svg>
)
export const Gutters = ({ _styled = true, ...props }) => (
  <svg
    x="0px"
    y="0px"
    width="53px"
    height="42px"
    viewBox="0 0 53 42"
    sx={
      _styled && {
        '.filled': {
          fill: props.color || 'primary',
          stroke: props.color || 'primary',
          strokeWidth: '2',
          strokeLinecap: 'round',
          strokeLinejoin: 'round',
          strokeMiterlimit: '10',
        },
      }
    }
    {...props}
  >
    <path
      d="M19 42H0V4c.68 2.03.97 4.35 2.15 6.03 1.53 2.16 3.71 5.31 5.75 5.42 10.03.56 20.11.25 30.52.25-1.19-2.98-2.37-5.35-3.07-7.86C34.65 5.3 34.43 2.62 34 0h3c1.01 4.12 1.39 8.54 3.2 12.27 2.32 4.78 6.87 4.61 9.56-.05C51.22 9.7 51.94 6.75 53 4v38H29v-6.18c9.84-2.24 12.72-7.58 9.79-17.14h-9.42c-.17 2.09-.31 3.88-.45 5.6-8.59 2.22-10.27 4.32-10.22 12.75.01 1.66.2 3.31.3 4.97z"
      fill="transparent"
    />
    <path
      className="filled"
      d="M34 0c.43 2.62.65 5.3 1.36 7.85.69 2.51 1.88 4.87 3.07 7.86-10.4 0-20.48.31-30.52-.25-2.04-.11-4.22-3.26-5.75-5.42C.97 8.35.68 6.03 0 4V0h34zM19 42c-.1-1.66-.29-3.31-.3-4.97-.05-8.42 1.63-10.53 10.22-12.75.14-1.72.28-3.5.45-5.6h9.42c2.93 9.56.05 14.89-9.79 17.14V42H19zM53 4c-1.06 2.75-1.78 5.7-3.24 8.22-2.7 4.66-7.24 4.83-9.56.05C38.39 8.54 38.01 4.12 37 0h16v4z"
    />
  </svg>
)
const Icons = {
  shield: Shield,
  communication: Communication,
  family: Family,
  tools: Tools,
  ribbon: Ribbon,
  roof: Roof,
  siding: Siding,
  window: Windows,
  gutter: Gutters,
}
export default Icons
